import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 19v-6a8 8 0 0 1 8 -8h6","key":"svg-0"}]]

/**
 * IconRadiusTopLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcmFkaXVzLXRvcC1sZWZ0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDE5di02YTggOCAwIDAgMSA4IC04aDYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/radius-top-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconRadiusTopLeft = createReactComponent('outline', 'radius-top-left', 'RadiusTopLeft', __iconNode);

export default IconRadiusTopLeft;